import { callMonitored, clocksNow, createHandlingStack } from '@datadog/browser-core';
import { onRumStart } from '../reactPlugin';
export function addReactError(error, info) {
    const handlingStack = createHandlingStack('react error');
    const startClocks = clocksNow();
    onRumStart((strategy) => {
        callMonitored(() => {
            var _a;
            strategy.addError({
                error,
                handlingStack,
                componentStack: (_a = info.componentStack) !== null && _a !== void 0 ? _a : undefined,
                context: { framework: 'react' },
                startClocks,
            });
        });
    });
}
//# sourceMappingURL=addReactError.js.map